import React, { Component } from "react";
import Window from "../../2/Controls/Window";
import Input from "../../2/Controls/Input";
import DiscardDialog from "./DiscardDialog";
import { BANK_FIELDS } from "./templateUtils";

class BankDetailsSheet extends Component {
  constructor(props) {
    super(props);
    this.state = { bank: { ...props.bank }, showDiscard: false, error: "" };
  }

  isDirty() {
    return BANK_FIELDS.some(
      (f) => (this.state.bank[f.key] || "") !== ((this.props.bank || {})[f.key] || "")
    );
  }

  onClose = () => {
    if (this.isDirty()) {
      this.setState({ showDiscard: true });
    } else {
      this.props.onClose();
    }
  };

  onButtonClick = (button) => {
    if (button === "Remove") {
      this.props.onSave(null);
      return;
    }
    if (!BANK_FIELDS.some((f) => (this.state.bank[f.key] || "").trim() !== "")) {
      this.setState({ error: "Please enter your bank details" });
      return;
    }
    this.props.onSave(this.state.bank);
  };

  render() {
    return (
      <React.Fragment>
        <Window
          header="Bank Details"
          modal={true}
          onClose={this.onClose}
          onButtonClick={this.onButtonClick}
          buttons={[
            ...(this.props.bank
              ? [{ Type: "secondary", Text: "Remove", Align: "left" }]
              : []),
            { Type: "primary", Text: "Save", Align: "right" }
          ]}
        >
          {BANK_FIELDS.map((f, index) => (
            <Input
              key={f.key}
              type="text"
              label={f.label}
              value={this.state.bank[f.key] || ""}
              error={index === 0 ? this.state.error : ""}
              onChange={(value) =>
                this.setState({
                  bank: { ...this.state.bank, [f.key]: value },
                  error: ""
                })
              }
            />
          ))}
        </Window>
        {this.state.showDiscard && (
          <DiscardDialog
            onStay={() => this.setState({ showDiscard: false })}
            onLeave={this.props.onClose}
          />
        )}
      </React.Fragment>
    );
  }
}

export default BankDetailsSheet;
